import { gql } from "@apollo/client";

export const GET_REVIEW_LIST = gql`
  query getReviewList($sku: String!) {
    products(filter: { sku: { eq: $sku } }) {
      items {
        review_count
        rating_summary
        reviews {
          items {
            average_rating
            summary
            text
            created_at
            nickname
          }
        }
      }
    }
  }
`;

export const GET_REVIEW_METADATA = gql`
  query ReviewMetaData {
    productReviewRatingsMetadata {
      items {
        id
        name
        values {
          value_id
          value
        }
      }
    }
  }
`;

export const ADD_REVIEW = gql`
  mutation (
    $sku: String!
    $nickname: String!
    $summary: String!
    $description: String!
    $ratings: [ProductReviewRatingInput]!
  ) {
    createProductReview(
      input: {
        sku: $sku
        nickname: $nickname
        summary: $summary
        text: $description
        ratings: $ratings
      }
    ) {
      review {
        nickname
        summary
        text
        average_rating
        ratings_breakdown {
          name
          value
        }
      }
    }
  }
`;

export default {
  getReviewList: GET_REVIEW_LIST,
  getReviewMetaData: GET_REVIEW_METADATA,
  addReview: ADD_REVIEW,
};
